import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { UploadObj } from '../../../classes/upload-obj.class';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { OnGetData } from '../../../services/dialog.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { UploadItemComponent } from '../../../upload-info/components/upload-item/upload-item.component';

@Component({
  selector: 'app-failed-uploads-dialog',
  templateUrl: './failed-uploads-dialog.component.html',
  styleUrls: ['./failed-uploads-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UploadItemComponent, ButtonDirective],
})
export class FailedUploadsDialogComponent implements OnGetData {
  private check = inject(ChangeDetectorRef);
  dialogName = 'failed-uploads';
  failedUploads: UploadObj[];
  gallery: GalleryDto;
  close: (...args) => void;

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40 };
  }

  async onGetData(data: { failedUploads: UploadObj[]; gallery: GalleryDto }, close: (...args) => void) {
    this.close = close;
    this.failedUploads = data.failedUploads;
    this.gallery = data.gallery;
    this.check.detectChanges();
  }

  dismiss() {
    this.close(true);
  }
}
